export enum CreditStatus {
  onHold = 'On Hold',
  softHold = 'Soft Hold',
  active = 'Active',
  unknown = 'Unknown',
}

export enum LastPaymentMethod {
  achDeduction = 'ACH Deduction',
  achOnline = 'ACH Online',
  cash = 'Cash',
  check = 'Check',
  creditCard = 'Credit Card',
  creditDebitOffset = 'Credit/Debit Offset',
  customerAch = 'Customer ACH',
  moneyOrderCashiersCheck = "Money Order/Cashiers' Check",
  onlineCheck = 'Online Check',
  otherAdjustment = 'Other/Adjustment',
  wire = 'Wire',
}

// These will be disabled and will change in the future
export enum Terms {
  securityDeposit = '00 SECURITY DEPOSIT',
  codCash = '01 COD-CASH',
  codCheck = '02 COD CHECK',
  codRequest = '03 COD REQUEST',
  halfPercentTwoDaysNetThree = '04 0.5% 2 DAYS (Net 3)',
  onePercentTenNetFourteen = '05 1% 10; NET 14',
  billToBillNetSeven = '06 BILL TO BILL, NET 7',
  codSlashCheck = '08 COD/CHECK',
  onePercentCodNetThree = '09 1% COD (Net 3)',
  onePercentTenNetEleven = '10 1% 10; NET 11',
  netSevenDays = '11 NET 7 DAYS',
  netTenDays = '12 NET 10 DAYS',
  netFourteenDays = '13 NET 14 DAYS',
  netFifteenDays = '14 NET 15 DAYS',
  netTwentyDays = '15 NET 20 DAYS',
  netTwentyOneDays = '16 NET 21 DAYS',
  netTwentyEightDays = '17 NET 28 DAYS',
  netThirtyDays = '18 NET 30 DAYS',
  netFortyFiveDays = '19 NET 45 DAYS',
  netSixtyDays = '20 NET 60 DAYS',
  netTenEom = '21 NET 10 EOM',
  eomThirty = '22 EOM 30',
  eomFortyFive = '23 EOM 45',
  twoPercentTenNetEleven = '24 2% 10 NET 11',
  onePercentFourteenNetFifteen = '25 1% 14 NET 15',
  twoPercentTenNetThirty = '26 2% 10 NET 30',
  twoPercentTenNetFifteen = '27 2% 10 NET 15',
  quarterPercentTenNetThirteen = '28 0.25% 10; NET 13',
  onePercent = '29 1% 10; Net 21',
  onePercentSevenNetTen = '30 1% 7 NET 10',
  quarterPercentTenNetThirty = '31 .25% 10 NET 30',
  onePercentTenNetThirty = '32 1% 10 NET 30',
  semiMonthly = '34 SEMI-MONTHLY',
  netThirtyDaysAafes = '35 NET 30 DAYS - AAFES',
  netTwoDays = '37 NET 2 DAYS',
  netThirtyTwoDays = '38 NET 32 DAYS',
  netThirtyFourDays = '40 NET 34 DAYS',
  onePercentThreeNetFour = '45 1% 3; NET 4 ',
  onePercentFourteenNetThirty = '47 1% 14 NET 30',
  halfPercentFourteenNetThirty = '49 .5% 14 NET 30',
  netTwentyFiveDays = '50 NET 25 DAYS',
  onePercentSevenNetEightDays = '55 1% 7, NET 8 DAYS',
  netNinety = '59 NET 90',
  sixtyNetThirtyFiveDays = '60 NET 35 DAYS',
  eom = '61 EOM 15',
  eomTwenty = '62 EOM 20',
  eomTwentyFive = '63 EOM 25',
  eomThirtySeven = '65 EOM 37',
  netFortyDays = '66 NET 40 DAYS',
  halfPercentSevenNetEightDays = '67 0.5% 7; Net 8 Days',
  eomSixty = '68 EOM 60',
  netSeventyFiveDays = '69 NET 75 DAYS',
  netNinetyEom = '70 NET 90 EOM',
  netSeventFiveEom = '71 NET 75 EOM',
  quarterPercentTwentyOneNetThirty = '73 .25% 21, NET 30',
  quarterPercentSevenNetEight = '74 .25% 7, NET 8',
  cashInAdvance = '75 CASH IN ADVANCE',
  seventSevenNetThirtyFiveDays = '77 NET 35 DAYS',
  quarterPercentFourteenNetTwentyEight = '80 0.25% 14; NET 28',
  prepaid = '81 PREPAID',
  netThreeDays = '83 NET 3 DAYS',
  netFiftyDays = '85 NET 50 DAYS',
  halfPercentCod = '86 0.5% COD',
  quarterPercentFifteenNetThirtyDays = '90 .25% 15; NET 30 DAYS',
  onePercentSevenNetTwentyOneDays = '91 1% 7; NET 21 DAYS',
  ninetyNinePointFivePercentCodNetSeven = '99.5% COD; NET 7',
  autoDeduction = '1A AUTO DEDUCTION',
  autoDeductWeeklyNetFourteen = 'A6 AUTO-DEDUCT WEEKLY, NET 14',
  achAutoDeduct = 'AD ACH-AUTO DEDUCT',
  biWeekly = 'BW BI-WEEKLY',
  creditCardDueDelivery = 'C1 Credit Card, due @ delivery',
  creditCard = 'CC CREDIT CARD',
  twoPercentTenNetFourteen = 'D0 2% 10; Net 14',
  halfPercentTenNetFourteen = 'D1 .5% 10, Net 14',
  onePercentCodNetFourteen = 'D2 1% COD; NET 14',
  onePercentSevenNetFourteen = 'D3 1% 7; NET 14',
  onePercentTwentyOneNetThirty = 'D4 1% 21; NET 30',
  onePercentSevenNetFortyFive = 'D5 1% 7; NET 45',
  threePercentSevenNetThirty = 'D6 3% 7; NET 30',
  twoPercentTenNetTwenty = 'D7 2% 10; Net 20',
  halfPercentSevenNetFortyFive = 'D8 .5% 7; Net 45',
  halfPercentSevenNetFourteen = 'D9 .5% 7; Net 14',
  onePercentSevenNetTenEom = 'E1 1% 7; Net 10 EOM',
  pointSixtyFivePercentTwentyEightNetThirtyDays = 'GG .65% 28 NET 30 DAYS',
  cashOnly = 'NS CASH ONLY',
  onePointTwoFivePercentTwentyWklyNetTwentyOne = 'R1 1.25% <20;WKLY NET21',
  quarterPercentTwentyOneNetEomTen = 'R2 .25% 21; Net EOM 10',
  halfPercentFourteenNetEomTen = 'R3 .5% 14; Net EOM 10',
  twoPercentNetTenEom = 'R4 2%; Net 10 EOM',
  onePercentNetTenEom = 'R5 1% Net 10 EOM',
  onePercentNetSeven = 'R6 1% Net 7',
  fivePercentNetFourteen = 'R7 5% Net 14',
  semiMonthlyEleventhAndTwentySixth = 'S1 SEMI-MONTHLY 11th & 26th',
  netFourteenSonic = 'SN NET 14 (SONIC)',
  weekly = 'W1 WEEKLY',
  weeklyNetTwentyOneDays = 'W2 WEEKLY, NET 21 DAYS',
  weeklyNetThirtyDays = 'W3 WEEKLY, NET 30 DAYS',
  weeklyNetFortyTwoDays = 'W4 WEEKLY, NET 42 DAYS',
  weeklyNetThirtyFiveDays = 'W5 WEEKLY, NET 35 DAYS',
  wSixWeeklyNetFourteenDays = 'W6 WEEKLY, NET 14 DAYS',
  halfPercentNetSevenDaysAch = 'W7 .50% Net 7 Days ACH',
  wEightWeeklyNetFourteenDays = 'W8 WEEKLY, NET 14 DAYS',
  wireTransferInAdv = 'WT WIRE TRANSFER IN ADV',
}
